"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _InputAdornment2 = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var InputAdornment = /*#__PURE__*/(0, _react.forwardRef)(function InputAdornment(props, ref) {
  var className = props.className,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["className"]);
  return /*#__PURE__*/_react.default.createElement(_InputAdornment2.default, Object.assign({}, otherProps, {
    className: (0, _classnames.default)('pds-input-adornment', className),
    ref: ref,
    disableTypography: true
  }));
});
InputAdornment.propTypes = {
  /**
   * The content of the component, usually a Button or string.
   */
  children: _propTypes.node.isRequired,

  /**
   * The CSS class name to apply to the root of the component.
   */
  className: _propTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.elementType,

  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the input on click.
   */
  disablePointerEvents: _propTypes.bool,

  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: (0, _propTypes.oneOf)(['start', 'end'])
};
InputAdornment.defaultProps = {
  component: 'div',
  disablePointerEvents: true
};
var _default = InputAdornment;
exports.default = _default;
